import React, { memo } from 'react';

import testIds from '@smart-tv/e2e/shared/variables';

import Button from '@smart-tv/components/button/button';
import Typography from '@smart-tv/components/typography';

import useFavoritesEdit from '@smart-tv/hooks/use-favorites-edit';
import styles from '../favorites.module.scss';

interface Props {
  onCreateClick: () => Promise<void>;
}

export const FavoritesHomeCreate = ({ onCreateClick }: Props) => {
  const { emptyFavoritesLists } = useFavoritesEdit();

  if (emptyFavoritesLists && emptyFavoritesLists.length > 0) {
    return (
      <div className={styles['favorites-home-root--create']}>
        <Button
          className={styles['favorites-home-root--create-btn']}
          onClick={onCreateClick}
          data-testid={testIds.favorites.home.create}
        >
          Opret ny kanalliste
        </Button>
      </div>
    );
  }

  return (
    <div
      className={styles['favorites-home-root--create']}
      data-testid={testIds.favorites.home.text}
    >
      <Typography variant="caption" textAlign="left">
        {'Du kan ikke oprette mere end 5 kanallister. Slet en liste for at oprette en ny'}
      </Typography>
    </div>
  );
};

export default memo(FavoritesHomeCreate);
